import { request, unwrap } from '../client';
import type { ApiResponse, ProductHostnameDto, ProductVerifyDnsResponse } from '../types';

// SASADM-0148 (saas-auth SASATH-0216 + SASATH-0330) — a product's derived console
// hostnames. Operator ruling: derived only — list what saas-auth minted and let the
// Operator verify DNS. No add/delete/primary from this client (those SASATH-0216
// endpoints exist but are out of scope here).
const base = (productId: number) => `/api/saas-admin/products/${productId}/hostnames`;

export const productHostnamesApi = {
  async list(productId: number): Promise<ProductHostnameDto[]> {
    const res = await request<ApiResponse<ProductHostnameDto[]>>('GET', base(productId));
    return unwrap(res);
  },

  // 200 even on a mismatch — the caller reads `check.match`, not the HTTP status.
  async verifyDns(productId: number, hostnameId: number): Promise<ProductVerifyDnsResponse> {
    const res = await request<ApiResponse<ProductVerifyDnsResponse>>(
      'POST',
      `${base(productId)}/${hostnameId}/verify-dns`,
    );
    return unwrap(res);
  },
};
